import path from 'path';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';

import { useAuthContext } from '@ascendnow/shared';
import {
    AscAnimationOnScroll,
    AscBanner,
    AscPlatformLayoutPortal,
    AscResourcesBanner,
    useResponsive,
} from '@ascendnow/ascend-components';

import { useAppDispatch, useAppSelector } from '../store';
import { fetchPlatformDashboardData } from '../store/dashboard/queries';
import { getRankListQuery } from '../store/rank/queries';
import {
    AscDashboardTracks,
    AscDashboardBaselineAssessment,
    AscDashboardEvents,
    AscDashboardSkillProgress,
    AscDashboardAside,
} from '../components/AscDashboardSections';
import styles from '../styles/pages/home.module.scss';

path.resolve('./next.config.js');

export default function Home() {
    const t = useTranslations('platform.dashboard');
    const dispatch = useAppDispatch();
    const { isMedium } = useResponsive();
    const { user } = useAuthContext();
    const { rankComparison } = useAppSelector((state) => state.dashboard.dashboard);

    useEffect(() => {
        dispatch(fetchPlatformDashboardData());
        dispatch(
            getRankListQuery({
                params: {
                    type: 'global',
                    period: 'allTime',
                    take: '5',
                    skip: '0',
                },
            })
        );

        //eslint-disable-next-line
    }, []);

    return (
        <div className={styles.ground}>
            <AscPlatformLayoutPortal
                title={`Hey, ${user?.name?.split(' ')?.[0]} \u{1F44B}`}
                subTitle={t('continueJourney')}
            />
            <AscBanner className={styles.banner} textOrHtml={rankComparison?.message} />
            <div className={styles.contentWrapper}>
                {!isMedium && (
                    <AscResourcesBanner
                        color={'PURPLE'}
                        variant={5}
                        text={`“${t('banner')}.”`}
                        className={styles.contentBanner}
                    />
                )}
                <AscAnimationOnScroll className={styles.content} as="section">
                    <AscDashboardTracks />
                    <AscDashboardBaselineAssessment />
                    <AscDashboardEvents />
                    <AscDashboardSkillProgress />
                </AscAnimationOnScroll>
                <AscDashboardAside />
            </div>
        </div>
    );
}
